var React = require('react');

function DownArrowBlackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L4.00852 4L7.01704 1","stroke":"black","strokeWidth":"1.4","strokeLinecap":"round","strokeLinejoin":"round"}));
}

DownArrowBlackInline.defaultProps = {"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none"};

module.exports = DownArrowBlackInline;

DownArrowBlackInline.default = DownArrowBlackInline;
